// extracted by mini-css-extract-plugin
export var autoExpand = "_2m-8";
export var container = "_2m-7";
export var containerWidth = "_2m-5";
export var disabled = "_2m-2";
export var error = "_2m-3";
export var fullWidth = "_2m-6";
export var inputWrapper = "_2m-0";
export var small = "_2m-1";
export var textarea = "_2m-4";